import Vue from "vue";

export const sucessMessageListener = "successMessage";
export const errorMessageListener = "errorMessage";
export const infoMessageListener = "infoMessage";
export const actionListener = "action";
export const newPopup = "newpopup";
export const closePopup = "closepopup";
export const closeAllPopup = "closeallpopup";
export const loginAction = "loginAction";

export const messageBus = new Vue();

export const sucessMessage = message => {
  messageBus.$emit(sucessMessageListener, message);
};

export const errorMessage = message => {
  messageBus.$emit(errorMessageListener, message);
};

export const infoMessage = message => {
  messageBus.$emit(infoMessageListener, message);
};

export const sendContinuosAction = (action, data) => {
  messageBus.$emit(action, data);
};

export const getContinuosAction = (action, callback) => {
  messageBus.$off(action);
  messageBus.$on(action, data => {
    callback(data);
  });
};

export const sendAction = data => {
  messageBus.$emit(actionListener, data);
};

export const getAction = callback => {
  messageBus.$once(actionListener, data => {
    callback(data);
  });
};

export const openPopupBus = data => {
  messageBus.$emit(newPopup, {
    component: data.component,
    props: data.props
  });
};

export const closePopupBus = () => {
  messageBus.$emit(closePopup);
};

// export const closeAllPopupBus = () => {
//   messageBus.$emit(closeAllPopup);
// };

export const getSuccessMessage = callback =>
  messageBus.$on(sucessMessageListener, message => callback(message));

export const getErrorMessage = callback =>
  messageBus.$on(errorMessageListener, message => callback(message));

export const getInfoMessage = callback =>
  messageBus.$on(infoMessageListener, message => callback(message));

export const getLoginAction = callback =>
  messageBus.$on(loginAction, data => callback());

export const sendLoginAction = () => {
  messageBus.$emit(closeAllPopup);
  messageBus.$emit(loginAction)
}



// WEBPACK FOOTER //
// /src/components/MessageBus.js